/* Auto-generated by 'apps/tinker/src/app/scripts/adf-csv-to-codes.ts'. Source: ADF July 2025 schedule (NSW for general, National for specialist). Do not edit manually — re-run the generator instead. */

import { ADA_CODE_MAP } from './ada';
import { Region } from '@principle-theorem/shared';
import {
  ServiceCodeType,
  type IServiceCode,
  type IServiceProvider,
  type ItemCodeAliases,
} from '../service-item';

export const GENERAL_ADF_CODES: ItemCodeAliases = Object.entries({
  D011: { ...ADA_CODE_MAP['011'], code: 'D011', rootCode: '011', fee: 62.16 },
  D012: { ...ADA_CODE_MAP['012'], code: 'D012', rootCode: '012', fee: 57.57 },
  D013: { ...ADA_CODE_MAP['013'], code: 'D013', rootCode: '013', fee: 53.53 },
  D014: { ...ADA_CODE_MAP['014'], code: 'D014', rootCode: '014', fee: 74.25 },
  D015: { ...ADA_CODE_MAP['015'], code: 'D015', rootCode: '015', fee: 98.43 },
  D016: { ...ADA_CODE_MAP['016'], code: 'D016', rootCode: '016', fee: 105.34 },
  D017: { ...ADA_CODE_MAP['017'], code: 'D017', rootCode: '017', fee: 107.07 },
  D018: { ...ADA_CODE_MAP['018'], code: 'D018', rootCode: '018', fee: 33.38 },
  D019: { ...ADA_CODE_MAP['019'], code: 'D019', rootCode: '019', fee: 26.48 },
  D022: { ...ADA_CODE_MAP['022'], code: 'D022', rootCode: '022', fee: 46.63 },
  D025: { ...ADA_CODE_MAP['025'], code: 'D025', rootCode: '025', fee: 67.93 },
  D026: { ...ADA_CODE_MAP['026'], code: 'D026', rootCode: '026', fee: 115.12 },
  D031: { ...ADA_CODE_MAP['031'], code: 'D031', rootCode: '031', fee: 59.29 },
  D033: { ...ADA_CODE_MAP['033'], code: 'D033', rootCode: '033', fee: 119.74 },
  D035: { ...ADA_CODE_MAP['035'], code: 'D035', rootCode: '035', fee: 127.78 },
  D036: { ...ADA_CODE_MAP['036'], code: 'D036', rootCode: '036', fee: 104.77 },
  D037: { ...ADA_CODE_MAP['037'], code: 'D037', rootCode: '037', fee: 143.91 },
  D038: { ...ADA_CODE_MAP['038'], code: 'D038', rootCode: '038', fee: 61.58 },
  D039: { ...ADA_CODE_MAP['039'], code: 'D039', rootCode: '039', fee: 150.81 },
  D041: { ...ADA_CODE_MAP['041'], code: 'D041', rootCode: '041', fee: 42.59 },
  D042: { ...ADA_CODE_MAP['042'], code: 'D042', rootCode: '042', fee: 50.66 },
  D043: { ...ADA_CODE_MAP['043'], code: 'D043', rootCode: '043', fee: 27.62 },
  D044: { ...ADA_CODE_MAP['044'], code: 'D044', rootCode: '044', fee: 28.78 },
  D047: { ...ADA_CODE_MAP['047'], code: 'D047', rootCode: '047', fee: 24.18 },
  D048: { ...ADA_CODE_MAP['048'], code: 'D048', rootCode: '048', fee: 50.66 },
  D051: { ...ADA_CODE_MAP['051'], code: 'D051', rootCode: '051', fee: 111.68 },
  D052: { ...ADA_CODE_MAP['052'], code: 'D052', rootCode: '052', fee: 62.16 },
  D053: { ...ADA_CODE_MAP['053'], code: 'D053', rootCode: '053', fee: 62.16 },
  D054: { ...ADA_CODE_MAP['054'], code: 'D054', rootCode: '054', fee: 62.16 },
  D055: { ...ADA_CODE_MAP['055'], code: 'D055', rootCode: '055', fee: 62.16 },
  D056: { ...ADA_CODE_MAP['056'], code: 'D056', rootCode: '056', fee: 62.16 },
  D059: { ...ADA_CODE_MAP['059'], code: 'D059', rootCode: '059', fee: 59.86 },
  D061: { ...ADA_CODE_MAP['061'], code: 'D061', rootCode: '061', fee: 32.24 },
  D071: { ...ADA_CODE_MAP['071'], code: 'D071', rootCode: '071', fee: 69.66 },
  D072: { ...ADA_CODE_MAP['072'], code: 'D072', rootCode: '072', fee: 47.22 },
  D073: { ...ADA_CODE_MAP['073'], code: 'D073', rootCode: '073', fee: 40.87 },
  D074: { ...ADA_CODE_MAP['074'], code: 'D074', rootCode: '074', fee: 127.78 },
  D075: { ...ADA_CODE_MAP['075'], code: 'D075', rootCode: '075', fee: 81.16 },
  D081: { ...ADA_CODE_MAP['081'], code: 'D081', rootCode: '081', fee: 81.16 },
  D082: { ...ADA_CODE_MAP['082'], code: 'D082', rootCode: '082', fee: 54.12 },
  D083: { ...ADA_CODE_MAP['083'], code: 'D083', rootCode: '083', fee: 109.38 },
  D085: { ...ADA_CODE_MAP['085'], code: 'D085', rootCode: '085', fee: 43.75 },
  D086: { ...ADA_CODE_MAP['086'], code: 'D086', rootCode: '086', fee: 33.38 },
  D087: { ...ADA_CODE_MAP['087'], code: 'D087', rootCode: '087', fee: 34.54 },
  D088: { ...ADA_CODE_MAP['088'], code: 'D088', rootCode: '088', fee: 40.29 },
  D089: { ...ADA_CODE_MAP['089'], code: 'D089', rootCode: '089', fee: 51.82 },
  D090: { ...ADA_CODE_MAP['090'], code: 'D090', rootCode: '090', fee: 57.57 },
  D091: { ...ADA_CODE_MAP['091'], code: 'D091', rootCode: '091', fee: 69.07 },
  D111: { ...ADA_CODE_MAP['111'], code: 'D111', rootCode: '111', fee: 58.72 },
  D113: { ...ADA_CODE_MAP['113'], code: 'D113', rootCode: '113', fee: 28.78 },
  D114: { ...ADA_CODE_MAP['114'], code: 'D114', rootCode: '114', fee: 118.58 },
  D115: { ...ADA_CODE_MAP['115'], code: 'D115', rootCode: '115', fee: 118.58 },
  D116: { ...ADA_CODE_MAP['116'], code: 'D116', rootCode: '116', fee: 75.4 },
  D117: { ...ADA_CODE_MAP['117'], code: 'D117', rootCode: '117', fee: 244.65 },
  D118: { ...ADA_CODE_MAP['118'], code: 'D118', rootCode: '118', fee: 73.68 },
  D119: { ...ADA_CODE_MAP['119'], code: 'D119', rootCode: '119', fee: 230.25 },
  D121: { ...ADA_CODE_MAP['121'], code: 'D121', rootCode: '121', fee: 36.27 },
  D122: { ...ADA_CODE_MAP['122'], code: 'D122', rootCode: '122', fee: 191.68 },
  D123: { ...ADA_CODE_MAP['123'], code: 'D123', rootCode: '123', fee: 51.23 },
  D131: { ...ADA_CODE_MAP['131'], code: 'D131', rootCode: '131', fee: 28.78 },
  D141: { ...ADA_CODE_MAP['141'], code: 'D141', rootCode: '141', fee: 31.1 },
  D151: { ...ADA_CODE_MAP['151'], code: 'D151', rootCode: '151', fee: 230.25 },
  D153: { ...ADA_CODE_MAP['153'], code: 'D153', rootCode: '153', fee: 286.67 },
  D161: { ...ADA_CODE_MAP['161'], code: 'D161', rootCode: '161', fee: 50.66 },
  D165: { ...ADA_CODE_MAP['165'], code: 'D165', rootCode: '165', fee: 43.75 },
  D171: { ...ADA_CODE_MAP['171'], code: 'D171', rootCode: '171', fee: 27.62 },
  D213: { ...ADA_CODE_MAP['213'], code: 'D213', rootCode: '213', fee: 105.9 },
  D221: { ...ADA_CODE_MAP['221'], code: 'D221', rootCode: '221', fee: 89.81 },
  D222: { ...ADA_CODE_MAP['222'], code: 'D222', rootCode: '222', fee: 70.8 },
  D223: { ...ADA_CODE_MAP['223'], code: 'D223', rootCode: '223', fee: 47.22 },
  D231: { ...ADA_CODE_MAP['231'], code: 'D231', rootCode: '231', fee: 107.07 },
  D232: { ...ADA_CODE_MAP['232'], code: 'D232', rootCode: '232', fee: 264.79 },
  D233: { ...ADA_CODE_MAP['233'], code: 'D233', rootCode: '233', fee: 276.3 },
  D234: { ...ADA_CODE_MAP['234'], code: 'D234', rootCode: '234', fee: 218.74 },
  D235: { ...ADA_CODE_MAP['235'], code: 'D235', rootCode: '235', fee: 466.25 },
  D236: { ...ADA_CODE_MAP['236'], code: 'D236', rootCode: '236', fee: 460.49 },
  D237: { ...ADA_CODE_MAP['237'], code: 'D237', rootCode: '237', fee: 287.81 },
  D238: { ...ADA_CODE_MAP['238'], code: 'D238', rootCode: '238', fee: 247.52 },
  D241: { ...ADA_CODE_MAP['241'], code: 'D241', rootCode: '241', fee: 232.55 },
  D242: { ...ADA_CODE_MAP['242'], code: 'D242', rootCode: '242', fee: 437.47 },
  D243: { ...ADA_CODE_MAP['243'], code: 'D243', rootCode: '243', fee: 460.49 },
  D244: { ...ADA_CODE_MAP['244'], code: 'D244', rootCode: '244', fee: 921 },
  D245: { ...ADA_CODE_MAP['245'], code: 'D245', rootCode: '245', fee: 197.43 },
  D246: { ...ADA_CODE_MAP['246'], code: 'D246', rootCode: '246', fee: 236.01 },
  D247: { ...ADA_CODE_MAP['247'], code: 'D247', rootCode: '247', fee: 921 },
  D250: { ...ADA_CODE_MAP['250'], code: 'D250', rootCode: '250', fee: 322.36 },
  D251: { ...ADA_CODE_MAP['251'], code: 'D251', rootCode: '251', fee: 172.68 },
  D311: { ...ADA_CODE_MAP['311'], code: 'D311', rootCode: '311', fee: 177.29 },
  D314: { ...ADA_CODE_MAP['314'], code: 'D314', rootCode: '314', fee: 244.07 },
  D322: { ...ADA_CODE_MAP['322'], code: 'D322', rootCode: '322', fee: 280.89 },
  D323: { ...ADA_CODE_MAP['323'], code: 'D323', rootCode: '323', fee: 359.19 },
  D324: { ...ADA_CODE_MAP['324'], code: 'D324', rootCode: '324', fee: 431.72 },
  D331: { ...ADA_CODE_MAP['331'], code: 'D331', rootCode: '331', fee: 287.81 },
  D332: { ...ADA_CODE_MAP['332'], code: 'D332', rootCode: '332', fee: 287.81 },
  D337: { ...ADA_CODE_MAP['337'], code: 'D337', rootCode: '337', fee: 189.96 },
  D338: { ...ADA_CODE_MAP['338'], code: 'D338', rootCode: '338', fee: 189.96 },
  D341: { ...ADA_CODE_MAP['341'], code: 'D341', rootCode: '341', fee: 189.96 },
  D343: { ...ADA_CODE_MAP['343'], code: 'D343', rootCode: '343', fee: 314.29 },
  D344: { ...ADA_CODE_MAP['344'], code: 'D344', rootCode: '344', fee: 633.19 },
  D345: { ...ADA_CODE_MAP['345'], code: 'D345', rootCode: '345', fee: 633.19 },
  D351: { ...ADA_CODE_MAP['351'], code: 'D351', rootCode: '351', fee: 212.98 },
  D352: { ...ADA_CODE_MAP['352'], code: 'D352', rootCode: '352', fee: 207.23 },
  D353: { ...ADA_CODE_MAP['353'], code: 'D353', rootCode: '353', fee: 287.81 },
  D354: { ...ADA_CODE_MAP['354'], code: 'D354', rootCode: '354', fee: 483.52 },
  D355: { ...ADA_CODE_MAP['355'], code: 'D355', rootCode: '355', fee: 483.52 },
  D359: { ...ADA_CODE_MAP['359'], code: 'D359', rootCode: '359', fee: 518.06 },
  D361: { ...ADA_CODE_MAP['361'], code: 'D361', rootCode: '361', fee: 109.38 },
  D363: { ...ADA_CODE_MAP['363'], code: 'D363', rootCode: '363', fee: 161.17 },
  D365: { ...ADA_CODE_MAP['365'], code: 'D365', rootCode: '365', fee: 828.89 },
  D366: { ...ADA_CODE_MAP['366'], code: 'D366', rootCode: '366', fee: 828.89 },
  D371: { ...ADA_CODE_MAP['371'], code: 'D371', rootCode: '371', fee: 172.68 },
  D373: { ...ADA_CODE_MAP['373'], code: 'D373', rootCode: '373', fee: 264.79 },
  D375: { ...ADA_CODE_MAP['375'], code: 'D375', rootCode: '375', fee: 218.74 },
  D376: { ...ADA_CODE_MAP['376'], code: 'D376', rootCode: '376', fee: 264.79 },
  D377: { ...ADA_CODE_MAP['377'], code: 'D377', rootCode: '377', fee: 98.43 },
  D378: { ...ADA_CODE_MAP['378'], code: 'D378', rootCode: '378', fee: 188.8 },
  D379: { ...ADA_CODE_MAP['379'], code: 'D379', rootCode: '379', fee: 166.93 },
  D381: { ...ADA_CODE_MAP['381'], code: 'D381', rootCode: '381', fee: 264.79 },
  D382: { ...ADA_CODE_MAP['382'], code: 'D382', rootCode: '382', fee: 330.98 },
  D384: { ...ADA_CODE_MAP['384'], code: 'D384', rootCode: '384', fee: 126.64 },
  D385: { ...ADA_CODE_MAP['385'], code: 'D385', rootCode: '385', fee: 307.38 },
  D386: { ...ADA_CODE_MAP['386'], code: 'D386', rootCode: '386', fee: 172.68 },
  D387: { ...ADA_CODE_MAP['387'], code: 'D387', rootCode: '387', fee: 172.68 },
  D388: { ...ADA_CODE_MAP['388'], code: 'D388', rootCode: '388', fee: 449.56 },
  D389: { ...ADA_CODE_MAP['389'], code: 'D389', rootCode: '389', fee: 77.14 },
  D391: { ...ADA_CODE_MAP['391'], code: 'D391', rootCode: '391', fee: 207.23 },
  D392: { ...ADA_CODE_MAP['392'], code: 'D392', rootCode: '392', fee: 80.59 },
  D393: { ...ADA_CODE_MAP['393'], code: 'D393', rootCode: '393', fee: 236.01 },
  D394: { ...ADA_CODE_MAP['394'], code: 'D394', rootCode: '394', fee: 345.38 },
  D395: { ...ADA_CODE_MAP['395'], code: 'D395', rootCode: '395', fee: 149.66 },
  D399: { ...ADA_CODE_MAP['399'], code: 'D399', rootCode: '399', fee: 46.05 },
  D411: { ...ADA_CODE_MAP['411'], code: 'D411', rootCode: '411', fee: 60.44 },
  D412: { ...ADA_CODE_MAP['412'], code: 'D412', rootCode: '412', fee: 138.15 },
  D414: { ...ADA_CODE_MAP['414'], code: 'D414', rootCode: '414', fee: 115.12 },
  D415: { ...ADA_CODE_MAP['415'], code: 'D415', rootCode: '415', fee: 287.81 },
  D416: { ...ADA_CODE_MAP['416'], code: 'D416', rootCode: '416', fee: 143.91 },
  D417: { ...ADA_CODE_MAP['417'], code: 'D417', rootCode: '417', fee: 287.81 },
  D418: { ...ADA_CODE_MAP['418'], code: 'D418', rootCode: '418', fee: 143.91 },
  D419: { ...ADA_CODE_MAP['419'], code: 'D419', rootCode: '419', fee: 236.01 },
  D421: { ...ADA_CODE_MAP['421'], code: 'D421', rootCode: '421', fee: 172.68 },
  D431: { ...ADA_CODE_MAP['431'], code: 'D431', rootCode: '431', fee: 184.21 },
  D432: { ...ADA_CODE_MAP['432'], code: 'D432', rootCode: '432', fee: 307.38 },
  D433: { ...ADA_CODE_MAP['433'], code: 'D433', rootCode: '433', fee: 184.21 },
  D434: { ...ADA_CODE_MAP['434'], code: 'D434', rootCode: '434', fee: 399.49 },
  D436: { ...ADA_CODE_MAP['436'], code: 'D436', rootCode: '436', fee: 189.96 },
  D437: { ...ADA_CODE_MAP['437'], code: 'D437', rootCode: '437', fee: 399.49 },
  D438: { ...ADA_CODE_MAP['438'], code: 'D438', rootCode: '438', fee: 205.5 },
  D445: { ...ADA_CODE_MAP['445'], code: 'D445', rootCode: '445', fee: 115.12 },
  D451: { ...ADA_CODE_MAP['451'], code: 'D451', rootCode: '451', fee: 115.12 },
  D452: { ...ADA_CODE_MAP['452'], code: 'D452', rootCode: '452', fee: 149.66 },
  D453: { ...ADA_CODE_MAP['453'], code: 'D453', rootCode: '453', fee: 149.66 },
  D455: { ...ADA_CODE_MAP['455'], code: 'D455', rootCode: '455', fee: 138.15 },
  D457: { ...ADA_CODE_MAP['457'], code: 'D457', rootCode: '457', fee: 117.43 },
  D458: { ...ADA_CODE_MAP['458'], code: 'D458', rootCode: '458', fee: 149.66 },
  D511: { ...ADA_CODE_MAP['511'], code: 'D511', rootCode: '511', fee: 151.39 },
  D512: { ...ADA_CODE_MAP['512'], code: 'D512', rootCode: '512', fee: 184.21 },
  D513: { ...ADA_CODE_MAP['513'], code: 'D513', rootCode: '513', fee: 214.14 },
  D514: { ...ADA_CODE_MAP['514'], code: 'D514', rootCode: '514', fee: 244.65 },
  D515: { ...ADA_CODE_MAP['515'], code: 'D515', rootCode: '515', fee: 290.7 },
  D521: { ...ADA_CODE_MAP['521'], code: 'D521', rootCode: '521', fee: 167.51 },
  D522: { ...ADA_CODE_MAP['522'], code: 'D522', rootCode: '522', fee: 194.56 },
  D523: { ...ADA_CODE_MAP['523'], code: 'D523', rootCode: '523', fee: 228.52 },
  D524: { ...ADA_CODE_MAP['524'], code: 'D524', rootCode: '524', fee: 253.27 },
  D525: { ...ADA_CODE_MAP['525'], code: 'D525', rootCode: '525', fee: 306.23 },
  D526: { ...ADA_CODE_MAP['526'], code: 'D526', rootCode: '526', fee: 345.38 },
  D531: { ...ADA_CODE_MAP['531'], code: 'D531', rootCode: '531', fee: 168.08 },
  D532: { ...ADA_CODE_MAP['532'], code: 'D532', rootCode: '532', fee: 214.14 },
  D533: { ...ADA_CODE_MAP['533'], code: 'D533', rootCode: '533', fee: 244.65 },
  D534: { ...ADA_CODE_MAP['534'], code: 'D534', rootCode: '534', fee: 282.07 },
  D535: { ...ADA_CODE_MAP['535'], code: 'D535', rootCode: '535', fee: 306.23 },
  D536: { ...ADA_CODE_MAP['536'], code: 'D536', rootCode: '536', fee: 345.38 },
  D541: { ...ADA_CODE_MAP['541'], code: 'D541', rootCode: '541', fee: 489.29 },
  D542: { ...ADA_CODE_MAP['542'], code: 'D542', rootCode: '542', fee: 720.1 },
  D543: { ...ADA_CODE_MAP['543'], code: 'D543', rootCode: '543', fee: 978.56 },
  D544: { ...ADA_CODE_MAP['544'], code: 'D544', rootCode: '544', fee: 1151.24 },
  D545: { ...ADA_CODE_MAP['545'], code: 'D545', rootCode: '545', fee: 1266.36 },
  D551: { ...ADA_CODE_MAP['551'], code: 'D551', rootCode: '551', fee: 518.06 },
  D552: { ...ADA_CODE_MAP['552'], code: 'D552', rootCode: '552', fee: 817.38 },
  D553: { ...ADA_CODE_MAP['553'], code: 'D553', rootCode: '553', fee: 1151.24 },
  D554: { ...ADA_CODE_MAP['554'], code: 'D554', rootCode: '554', fee: 1266.36 },
  D555: { ...ADA_CODE_MAP['555'], code: 'D555', rootCode: '555', fee: 1381.49 },
  D556: { ...ADA_CODE_MAP['556'], code: 'D556', rootCode: '556', fee: 1266.36 },
  D571: { ...ADA_CODE_MAP['571'], code: 'D571', rootCode: '571', fee: 31.1 },
  D572: { ...ADA_CODE_MAP['572'], code: 'D572', rootCode: '572', fee: 105.34 },
  D574: { ...ADA_CODE_MAP['574'], code: 'D574', rootCode: '574', fee: 151.39 },
  D575: { ...ADA_CODE_MAP['575'], code: 'D575', rootCode: '575', fee: 37.42 },
  D577: { ...ADA_CODE_MAP['577'], code: 'D577', rootCode: '577', fee: 35.69 },
  D578: { ...ADA_CODE_MAP['578'], code: 'D578', rootCode: '578', fee: 35.69 },
  D579: { ...ADA_CODE_MAP['579'], code: 'D579', rootCode: '579', fee: 167.51 },
  D586: { ...ADA_CODE_MAP['586'], code: 'D586', rootCode: '586', fee: 207.23 },
  D587: { ...ADA_CODE_MAP['587'], code: 'D587', rootCode: '587', fee: 186.49 },
  D588: { ...ADA_CODE_MAP['588'], code: 'D588', rootCode: '588', fee: 322.36 },
  D595: { ...ADA_CODE_MAP['595'], code: 'D595', rootCode: '595', fee: 126.64 },
  D596: { ...ADA_CODE_MAP['596'], code: 'D596', rootCode: '596', fee: 121.45 },
  D597: { ...ADA_CODE_MAP['597'], code: 'D597', rootCode: '597', fee: 184.21 },
  D611: { ...ADA_CODE_MAP['611'], code: 'D611', rootCode: '611', fee: 805.87 },
  D613: { ...ADA_CODE_MAP['613'], code: 'D613', rootCode: '613', fee: 1841.99 },
  D615: { ...ADA_CODE_MAP['615'], code: 'D615', rootCode: '615', fee: 1841.99 },
  D618: { ...ADA_CODE_MAP['618'], code: 'D618', rootCode: '618', fee: 1841.99 },
  D625: { ...ADA_CODE_MAP['625'], code: 'D625', rootCode: '625', fee: 460.49 },
  D627: { ...ADA_CODE_MAP['627'], code: 'D627', rootCode: '627', fee: 230.25 },
  D629: { ...ADA_CODE_MAP['629'], code: 'D629', rootCode: '629', fee: 460.49 },
  D631: { ...ADA_CODE_MAP['631'], code: 'D631', rootCode: '631', fee: 230.25 },
  D632: { ...ADA_CODE_MAP['632'], code: 'D632', rootCode: '632', fee: 322.36 },
  D633: { ...ADA_CODE_MAP['633'], code: 'D633', rootCode: '633', fee: 230.25 },
  D634: { ...ADA_CODE_MAP['634'], code: 'D634', rootCode: '634', fee: 345.38 },
  D642: { ...ADA_CODE_MAP['642'], code: 'D642', rootCode: '642', fee: 575.63 },
  D643: { ...ADA_CODE_MAP['643'], code: 'D643', rootCode: '643', fee: 1381.49 },
  D644: { ...ADA_CODE_MAP['644'], code: 'D644', rootCode: '644', fee: 287.81 },
  D645: { ...ADA_CODE_MAP['645'], code: 'D645', rootCode: '645', fee: 287.81 },
  D649: { ...ADA_CODE_MAP['649'], code: 'D649', rootCode: '649', fee: 333.85 },
  D651: { ...ADA_CODE_MAP['651'], code: 'D651', rootCode: '651', fee: 138.15 },
  D652: { ...ADA_CODE_MAP['652'], code: 'D652', rootCode: '652', fee: 167.51 },
  D653: { ...ADA_CODE_MAP['653'], code: 'D653', rootCode: '653', fee: 198.02 },
  D655: { ...ADA_CODE_MAP['655'], code: 'D655', rootCode: '655', fee: 132.4 },
  D656: { ...ADA_CODE_MAP['656'], code: 'D656', rootCode: '656', fee: 151.39 },
  D658: { ...ADA_CODE_MAP['658'], code: 'D658', rootCode: '658', fee: 228.52 },
  D659: { ...ADA_CODE_MAP['659'], code: 'D659', rootCode: '659', fee: 183.62 },
  D661: { ...ADA_CODE_MAP['661'], code: 'D661', rootCode: '661', fee: 1151.24 },
  D663: { ...ADA_CODE_MAP['663'], code: 'D663', rootCode: '663', fee: 345.38 },
  D664: { ...ADA_CODE_MAP['664'], code: 'D664', rootCode: '664', fee: 345.38 },
  D665: { ...ADA_CODE_MAP['665'], code: 'D665', rootCode: '665', fee: 1151.24 },
  D666: { ...ADA_CODE_MAP['666'], code: 'D666', rootCode: '666', fee: 1381.49 },
  D667: { ...ADA_CODE_MAP['667'], code: 'D667', rootCode: '667', fee: 1381.49 },
  D668: { ...ADA_CODE_MAP['668'], code: 'D668', rootCode: '668', fee: 207.23 },
  D669: { ...ADA_CODE_MAP['669'], code: 'D669', rootCode: '669', fee: 230.25 },
  D671: { ...ADA_CODE_MAP['671'], code: 'D671', rootCode: '671', fee: 1841.99 },
  D672: { ...ADA_CODE_MAP['672'], code: 'D672', rootCode: '672', fee: 1841.99 },
  D673: { ...ADA_CODE_MAP['673'], code: 'D673', rootCode: '673', fee: 1841.99 },
  D678: { ...ADA_CODE_MAP['678'], code: 'D678', rootCode: '678', fee: 391.42 },
  D679: { ...ADA_CODE_MAP['679'], code: 'D679', rootCode: '679', fee: 402.94 },
  D684: { ...ADA_CODE_MAP['684'], code: 'D684', rootCode: '684', fee: 2129.8 },
  D688: { ...ADA_CODE_MAP['688'], code: 'D688', rootCode: '688', fee: 2129.8 },
  D689: { ...ADA_CODE_MAP['689'], code: 'D689', rootCode: '689', fee: 472.01 },
  D690: { ...ADA_CODE_MAP['690'], code: 'D690', rootCode: '690', fee: 345.38 },
  D691: { ...ADA_CODE_MAP['691'], code: 'D691', rootCode: '691', fee: 633.19 },
  D711: { ...ADA_CODE_MAP['711'], code: 'D711', rootCode: '711', fee: 1381.49 },
  D712: { ...ADA_CODE_MAP['712'], code: 'D712', rootCode: '712', fee: 1381.49 },
  D713: { ...ADA_CODE_MAP['713'], code: 'D713', rootCode: '713', fee: 552.6 },
  D714: { ...ADA_CODE_MAP['714'], code: 'D714', rootCode: '714', fee: 552.6 },
  D715: { ...ADA_CODE_MAP['715'], code: 'D715', rootCode: '715', fee: 1105.19 },
  D716: { ...ADA_CODE_MAP['716'], code: 'D716', rootCode: '716', fee: 391.42 },
  D719: { ...ADA_CODE_MAP['719'], code: 'D719', rootCode: '719', fee: 2762.99 },
  D721: { ...ADA_CODE_MAP['721'], code: 'D721', rootCode: '721', fee: 805.87 },
  D722: { ...ADA_CODE_MAP['722'], code: 'D722', rootCode: '722', fee: 805.87 },
  D723: { ...ADA_CODE_MAP['723'], code: 'D723', rootCode: '723', fee: 324.65 },
  D724: { ...ADA_CODE_MAP['724'], code: 'D724', rootCode: '724', fee: 324.65 },
  D727: { ...ADA_CODE_MAP['727'], code: 'D727', rootCode: '727', fee: 1496.62 },
  D728: { ...ADA_CODE_MAP['728'], code: 'D728', rootCode: '728', fee: 1496.62 },
  D731: { ...ADA_CODE_MAP['731'], code: 'D731', rootCode: '731', fee: 51.82 },
  D732: { ...ADA_CODE_MAP['732'], code: 'D732', rootCode: '732', fee: 51.82 },
  D733: { ...ADA_CODE_MAP['733'], code: 'D733', rootCode: '733', fee: 51.82 },
  D734: { ...ADA_CODE_MAP['734'], code: 'D734', rootCode: '734', fee: 57.57 },
  D735: { ...ADA_CODE_MAP['735'], code: 'D735', rootCode: '735', fee: 253.27 },
  D736: { ...ADA_CODE_MAP['736'], code: 'D736', rootCode: '736', fee: 51.82 },
  D737: { ...ADA_CODE_MAP['737'], code: 'D737', rootCode: '737', fee: 255.58 },
  D738: { ...ADA_CODE_MAP['738'], code: 'D738', rootCode: '738', fee: 149.66 },
  D739: { ...ADA_CODE_MAP['739'], code: 'D739', rootCode: '739', fee: 78.28 },
  D741: { ...ADA_CODE_MAP['741'], code: 'D741', rootCode: '741', fee: 57.57 },
  D743: { ...ADA_CODE_MAP['743'], code: 'D743', rootCode: '743', fee: 460.49 },
  D744: { ...ADA_CODE_MAP['744'], code: 'D744', rootCode: '744', fee: 443.23 },
  D745: { ...ADA_CODE_MAP['745'], code: 'D745', rootCode: '745', fee: 495.04 },
  D746: { ...ADA_CODE_MAP['746'], code: 'D746', rootCode: '746', fee: 458.77 },
  D751: { ...ADA_CODE_MAP['751'], code: 'D751', rootCode: '751', fee: 230.25 },
  D752: { ...ADA_CODE_MAP['752'], code: 'D752', rootCode: '752', fee: 207.23 },
  D753: { ...ADA_CODE_MAP['753'], code: 'D753', rootCode: '753', fee: 51.82 },
  D754: { ...ADA_CODE_MAP['754'], code: 'D754', rootCode: '754', fee: 174.99 },
  D761: { ...ADA_CODE_MAP['761'], code: 'D761', rootCode: '761', fee: 166.93 },
  D762: { ...ADA_CODE_MAP['762'], code: 'D762', rootCode: '762', fee: 189.96 },
  D763: { ...ADA_CODE_MAP['763'], code: 'D763', rootCode: '763', fee: 172.68 },
  D764: { ...ADA_CODE_MAP['764'], code: 'D764', rootCode: '764', fee: 172.68 },
  D765: { ...ADA_CODE_MAP['765'], code: 'D765', rootCode: '765', fee: 184.21 },
  D766: { ...ADA_CODE_MAP['766'], code: 'D766', rootCode: '766', fee: 166.93 },
  D768: { ...ADA_CODE_MAP['768'], code: 'D768', rootCode: '768', fee: 190.53 },
  D769: { ...ADA_CODE_MAP['769'], code: 'D769', rootCode: '769', fee: 230.25 },
  D771: { ...ADA_CODE_MAP['771'], code: 'D771', rootCode: '771', fee: 115.12 },
  D772: { ...ADA_CODE_MAP['772'], code: 'D772', rootCode: '772', fee: 311.42 },
  D773: { ...ADA_CODE_MAP['773'], code: 'D773', rootCode: '773', fee: 345.38 },
  D774: { ...ADA_CODE_MAP['774'], code: 'D774', rootCode: '774', fee: 103.62 },
  D775: { ...ADA_CODE_MAP['775'], code: 'D775', rootCode: '775', fee: 59.86 },
  D776: { ...ADA_CODE_MAP['776'], code: 'D776', rootCode: '776', fee: 58.72 },
  D777: { ...ADA_CODE_MAP['777'], code: 'D777', rootCode: '777', fee: 48.35 },
  D778: { ...ADA_CODE_MAP['778'], code: 'D778', rootCode: '778', fee: 184.21 },
  D779: { ...ADA_CODE_MAP['779'], code: 'D779', rootCode: '779', fee: 230.25 },
  D811: { ...ADA_CODE_MAP['811'], code: 'D811', rootCode: '811', fee: 287.81 },
  D821: { ...ADA_CODE_MAP['821'], code: 'D821', rootCode: '821', fee: 1093.68 },
  D823: { ...ADA_CODE_MAP['823'], code: 'D823', rootCode: '823', fee: 1962.88 },
  D824: { ...ADA_CODE_MAP['824'], code: 'D824', rootCode: '824', fee: 460.49 },
  D825: { ...ADA_CODE_MAP['825'], code: 'D825', rootCode: '825', fee: 1049.93 },
  D829: { ...ADA_CODE_MAP['829'], code: 'D829', rootCode: '829', fee: 750.04 },
  D831: { ...ADA_CODE_MAP['831'], code: 'D831', rootCode: '831', fee: 1795.95 },
  D833: { ...ADA_CODE_MAP['833'], code: 'D833', rootCode: '833', fee: 75.98 },
  D841: { ...ADA_CODE_MAP['841'], code: 'D841', rootCode: '841', fee: 495.04 },
  D842: { ...ADA_CODE_MAP['842'], code: 'D842', rootCode: '842', fee: 592.9 },
  D843: { ...ADA_CODE_MAP['843'], code: 'D843', rootCode: '843', fee: 1496.62 },
  D845: { ...ADA_CODE_MAP['845'], code: 'D845', rootCode: '845', fee: 437.47 },
  D846: { ...ADA_CODE_MAP['846'], code: 'D846', rootCode: '846', fee: 293.57 },
  D851: { ...ADA_CODE_MAP['851'], code: 'D851', rootCode: '851', fee: 921 },
  D862: { ...ADA_CODE_MAP['862'], code: 'D862', rootCode: '862', fee: 138.15 },
  D871: { ...ADA_CODE_MAP['871'], code: 'D871', rootCode: '871', fee: 172.68 },
  D872: { ...ADA_CODE_MAP['872'], code: 'D872', rootCode: '872', fee: 121.45 },
  D873: { ...ADA_CODE_MAP['873'], code: 'D873', rootCode: '873', fee: 172.68 },
  D874: { ...ADA_CODE_MAP['874'], code: 'D874', rootCode: '874', fee: 59.86 },
  D875: { ...ADA_CODE_MAP['875'], code: 'D875', rootCode: '875', fee: 172.68 },
  D876: { ...ADA_CODE_MAP['876'], code: 'D876', rootCode: '876', fee: 172.68 },
  D877: { ...ADA_CODE_MAP['877'], code: 'D877', rootCode: '877', fee: 178.46 },
  D878: { ...ADA_CODE_MAP['878'], code: 'D878', rootCode: '878', fee: 230.25 },
  D911: { ...ADA_CODE_MAP['911'], code: 'D911', rootCode: '911', fee: 91.53 },
  D915: { ...ADA_CODE_MAP['915'], code: 'D915', rootCode: '915', fee: 110.53 },
  D916: { ...ADA_CODE_MAP['916'], code: 'D916', rootCode: '916', fee: 72.53 },
  D926: { ...ADA_CODE_MAP['926'], code: 'D926', rootCode: '926', fee: 123.19 },
  D927: { ...ADA_CODE_MAP['927'], code: 'D927', rootCode: '927', fee: 55.25 },
  D928: { ...ADA_CODE_MAP['928'], code: 'D928', rootCode: '928', fee: 115.12 },
  D941: { ...ADA_CODE_MAP['941'], code: 'D941', rootCode: '941', fee: 48.35 },
  D942: { ...ADA_CODE_MAP['942'], code: 'D942', rootCode: '942', fee: 115.12 },
  D943: { ...ADA_CODE_MAP['943'], code: 'D943', rootCode: '943', fee: 63.9 },
  D944: { ...ADA_CODE_MAP['944'], code: 'D944', rootCode: '944', fee: 183.06 },
  D945: { ...ADA_CODE_MAP['945'], code: 'D945', rootCode: '945', fee: 57.57 },
  D949: { ...ADA_CODE_MAP['949'], code: 'D949', rootCode: '949', fee: 143.91 },
  D961: { ...ADA_CODE_MAP['961'], code: 'D961', rootCode: '961', fee: 35.69 },
  D963: { ...ADA_CODE_MAP['963'], code: 'D963', rootCode: '963', fee: 100.73 },
  D964: { ...ADA_CODE_MAP['964'], code: 'D964', rootCode: '964', fee: 99 },
  D965: { ...ADA_CODE_MAP['965'], code: 'D965', rootCode: '965', fee: 760.98 },
  D966: { ...ADA_CODE_MAP['966'], code: 'D966', rootCode: '966', fee: 103.62 },
  D967: { ...ADA_CODE_MAP['967'], code: 'D967', rootCode: '967', fee: 228.52 },
  D968: { ...ADA_CODE_MAP['968'], code: 'D968', rootCode: '968', fee: 180.17 },
  D971: { ...ADA_CODE_MAP['971'], code: 'D971', rootCode: '971', fee: 46.05 },
  D972: { ...ADA_CODE_MAP['972'], code: 'D972', rootCode: '972', fee: 192.27 },
  D981: { ...ADA_CODE_MAP['981'], code: 'D981', rootCode: '981', fee: 120.88 },
  D982: { ...ADA_CODE_MAP['982'], code: 'D982', rootCode: '982', fee: 74.84 },
  D983: { ...ADA_CODE_MAP['983'], code: 'D983', rootCode: '983', fee: 1013.1 },
  D984: { ...ADA_CODE_MAP['984'], code: 'D984', rootCode: '984', fee: 1669.3 },
  D985: { ...ADA_CODE_MAP['985'], code: 'D985', rootCode: '985', fee: 192.27 },
  D986: { ...ADA_CODE_MAP['986'], code: 'D986', rootCode: '986', fee: 54.12 },
  D987: { ...ADA_CODE_MAP['987'], code: 'D987', rootCode: '987', fee: 74.25 },
  D990: { ...ADA_CODE_MAP['990'], code: 'D990', rootCode: '990', fee: 40.29 },
}).reduce(
  (codes, [key, code]) => ({
    ...codes,
    [key]: { ...(code as IServiceCode), type: ServiceCodeType.ADF },
  }),
  {} as ItemCodeAliases
);

export const SPECIALIST_ADF_CODES: ItemCodeAliases = Object.entries({
  S011: { ...ADA_CODE_MAP['011'], code: 'S011', rootCode: '011', fee: 113.99 },
  S012: { ...ADA_CODE_MAP['012'], code: 'S012', rootCode: '012', fee: 83.53 },
  S013: { ...ADA_CODE_MAP['013'], code: 'S013', rootCode: '013', fee: 60.44 },
  S014: { ...ADA_CODE_MAP['014'], code: 'S014', rootCode: '014', fee: 121.25 },
  S015: { ...ADA_CODE_MAP['015'], code: 'S015', rootCode: '015', fee: 188.91 },
  S016: { ...ADA_CODE_MAP['016'], code: 'S016', rootCode: '016', fee: 181.67 },
  S017: { ...ADA_CODE_MAP['017'], code: 'S017', rootCode: '017', fee: 265.95 },
  S018: { ...ADA_CODE_MAP['018'], code: 'S018', rootCode: '018', fee: 80.38 },
  S019: { ...ADA_CODE_MAP['019'], code: 'S019', rootCode: '019', fee: 43.16 },
  S022: { ...ADA_CODE_MAP['022'], code: 'S022', rootCode: '022', fee: 65.89 },
  S025: { ...ADA_CODE_MAP['025'], code: 'S025', rootCode: '025', fee: 117.49 },
  S026: { ...ADA_CODE_MAP['026'], code: 'S026', rootCode: '026', fee: 139.01 },
  S031: { ...ADA_CODE_MAP['031'], code: 'S031', rootCode: '031', fee: 133.95 },
  S033: { ...ADA_CODE_MAP['033'], code: 'S033', rootCode: '033', fee: 169.25 },
  S035: { ...ADA_CODE_MAP['035'], code: 'S035', rootCode: '035', fee: 193.17 },
  S036: { ...ADA_CODE_MAP['036'], code: 'S036', rootCode: '036', fee: 270.2 },
  S037: { ...ADA_CODE_MAP['037'], code: 'S037', rootCode: '037', fee: 171.41 },
  S038: { ...ADA_CODE_MAP['038'], code: 'S038', rootCode: '038', fee: 168.38 },
  S039: { ...ADA_CODE_MAP['039'], code: 'S039', rootCode: '039', fee: 270.3 },
  S041: { ...ADA_CODE_MAP['041'], code: 'S041', rootCode: '041', fee: 101.66 },
  S042: { ...ADA_CODE_MAP['042'], code: 'S042', rootCode: '042', fee: 81.84 },
  S043: { ...ADA_CODE_MAP['043'], code: 'S043', rootCode: '043', fee: 73.14 },
  S044: { ...ADA_CODE_MAP['044'], code: 'S044', rootCode: '044', fee: 92 },
  S047: { ...ADA_CODE_MAP['047'], code: 'S047', rootCode: '047', fee: 73.68 },
  S048: { ...ADA_CODE_MAP['048'], code: 'S048', rootCode: '048', fee: 78.94 },
  S051: { ...ADA_CODE_MAP['051'], code: 'S051', rootCode: '051', fee: 236.57 },
  S052: { ...ADA_CODE_MAP['052'], code: 'S052', rootCode: '052', fee: 1095.9 },
  S053: { ...ADA_CODE_MAP['053'], code: 'S053', rootCode: '053', fee: 166.46 },
  S054: { ...ADA_CODE_MAP['054'], code: 'S054', rootCode: '054', fee: 69.07 },
  S055: { ...ADA_CODE_MAP['055'], code: 'S055', rootCode: '055', fee: 69.07 },
  S056: { ...ADA_CODE_MAP['056'], code: 'S056', rootCode: '056', fee: 69.07 },
  S059: { ...ADA_CODE_MAP['059'], code: 'S059', rootCode: '059', fee: 80.01 },
  S061: { ...ADA_CODE_MAP['061'], code: 'S061', rootCode: '061', fee: 44.37 },
  S071: { ...ADA_CODE_MAP['071'], code: 'S071', rootCode: '071', fee: 109.83 },
  S072: { ...ADA_CODE_MAP['072'], code: 'S072', rootCode: '072', fee: 51.74 },
  S073: { ...ADA_CODE_MAP['073'], code: 'S073', rootCode: '073', fee: 50.53 },
  S074: { ...ADA_CODE_MAP['074'], code: 'S074', rootCode: '074', fee: 287.81 },
  S075: { ...ADA_CODE_MAP['075'], code: 'S075', rootCode: '075', fee: 55.6 },
  S081: { ...ADA_CODE_MAP['081'], code: 'S081', rootCode: '081', fee: 100.46 },
  S082: { ...ADA_CODE_MAP['082'], code: 'S082', rootCode: '082', fee: 192.27 },
  S083: { ...ADA_CODE_MAP['083'], code: 'S083', rootCode: '083', fee: 139.74 },
  S085: { ...ADA_CODE_MAP['085'], code: 'S085', rootCode: '085', fee: 277.79 },
  S086: { ...ADA_CODE_MAP['086'], code: 'S086', rootCode: '086', fee: 228.71 },
  S087: { ...ADA_CODE_MAP['087'], code: 'S087', rootCode: '087', fee: 34.54 },
  S088: { ...ADA_CODE_MAP['088'], code: 'S088', rootCode: '088', fee: 40.29 },
  S089: { ...ADA_CODE_MAP['089'], code: 'S089', rootCode: '089', fee: 51.82 },
  S090: { ...ADA_CODE_MAP['090'], code: 'S090', rootCode: '090', fee: 57.57 },
  S091: { ...ADA_CODE_MAP['091'], code: 'S091', rootCode: '091', fee: 69.07 },
  S111: { ...ADA_CODE_MAP['111'], code: 'S111', rootCode: '111', fee: 95.49 },
  S113: { ...ADA_CODE_MAP['113'], code: 'S113', rootCode: '113', fee: 36.14 },
  S114: { ...ADA_CODE_MAP['114'], code: 'S114', rootCode: '114', fee: 159.08 },
  S115: { ...ADA_CODE_MAP['115'], code: 'S115', rootCode: '115', fee: 138.15 },
  S116: { ...ADA_CODE_MAP['116'], code: 'S116', rootCode: '116', fee: 86.43 },
  S117: { ...ADA_CODE_MAP['117'], code: 'S117', rootCode: '117', fee: 479.25 },
  S118: { ...ADA_CODE_MAP['118'], code: 'S118', rootCode: '118', fee: 92.35 },
  S119: { ...ADA_CODE_MAP['119'], code: 'S119', rootCode: '119', fee: 194.75 },
  S121: { ...ADA_CODE_MAP['121'], code: 'S121', rootCode: '121', fee: 61.29 },
  S122: { ...ADA_CODE_MAP['122'], code: 'S122', rootCode: '122', fee: 86.56 },
  S123: { ...ADA_CODE_MAP['123'], code: 'S123', rootCode: '123', fee: 58.72 },
  S131: { ...ADA_CODE_MAP['131'], code: 'S131', rootCode: '131', fee: 61.58 },
  S141: { ...ADA_CODE_MAP['141'], code: 'S141', rootCode: '141', fee: 83.57 },
  S151: { ...ADA_CODE_MAP['151'], code: 'S151', rootCode: '151', fee: 253.27 },
  S153: { ...ADA_CODE_MAP['153'], code: 'S153', rootCode: '153', fee: 369.66 },
  S161: { ...ADA_CODE_MAP['161'], code: 'S161', rootCode: '161', fee: 81.6 },
  S165: { ...ADA_CODE_MAP['165'], code: 'S165', rootCode: '165', fee: 61.03 },
  S171: { ...ADA_CODE_MAP['171'], code: 'S171', rootCode: '171', fee: 90.05 },
  S213: { ...ADA_CODE_MAP['213'], code: 'S213', rootCode: '213', fee: 125.72 },
  S221: { ...ADA_CODE_MAP['221'], code: 'S221', rootCode: '221', fee: 242.23 },
  S222: { ...ADA_CODE_MAP['222'], code: 'S222', rootCode: '222', fee: 70.8 },
  S223: { ...ADA_CODE_MAP['223'], code: 'S223', rootCode: '223', fee: 97.31 },
  S231: { ...ADA_CODE_MAP['231'], code: 'S231', rootCode: '231', fee: 181.32 },
  S232: { ...ADA_CODE_MAP['232'], code: 'S232', rootCode: '232', fee: 326.38 },
  S233: { ...ADA_CODE_MAP['233'], code: 'S233', rootCode: '233', fee: 132.93 },
  S234: { ...ADA_CODE_MAP['234'], code: 'S234', rootCode: '234', fee: 264.13 },
  S235: { ...ADA_CODE_MAP['235'], code: 'S235', rootCode: '235', fee: 788.63 },
  S236: { ...ADA_CODE_MAP['236'], code: 'S236', rootCode: '236', fee: 888.07 },
  S237: { ...ADA_CODE_MAP['237'], code: 'S237', rootCode: '237', fee: 405.68 },
  S238: { ...ADA_CODE_MAP['238'], code: 'S238', rootCode: '238', fee: 694.44 },
  S241: { ...ADA_CODE_MAP['241'], code: 'S241', rootCode: '241', fee: 450.64 },
  S242: { ...ADA_CODE_MAP['242'], code: 'S242', rootCode: '242', fee: 980.28 },
  S243: { ...ADA_CODE_MAP['243'], code: 'S243', rootCode: '243', fee: 1126.24 },
  S244: { ...ADA_CODE_MAP['244'], code: 'S244', rootCode: '244', fee: 921 },
  S245: { ...ADA_CODE_MAP['245'], code: 'S245', rootCode: '245', fee: 286.12 },
  S246: { ...ADA_CODE_MAP['246'], code: 'S246', rootCode: '246', fee: 389.24 },
  S247: { ...ADA_CODE_MAP['247'], code: 'S247', rootCode: '247', fee: 389.24 },
  S250: { ...ADA_CODE_MAP['250'], code: 'S250', rootCode: '250', fee: 322.36 },
  S251: { ...ADA_CODE_MAP['251'], code: 'S251', rootCode: '251', fee: 278.02 },
  S311: { ...ADA_CODE_MAP['311'], code: 'S311', rootCode: '311', fee: 208.16 },
  S314: { ...ADA_CODE_MAP['314'], code: 'S314', rootCode: '314', fee: 284.92 },
  S322: { ...ADA_CODE_MAP['322'], code: 'S322', rootCode: '322', fee: 361.56 },
  S323: { ...ADA_CODE_MAP['323'], code: 'S323', rootCode: '323', fee: 448.83 },
  S324: { ...ADA_CODE_MAP['324'], code: 'S324', rootCode: '324', fee: 555.7 },
  S331: { ...ADA_CODE_MAP['331'], code: 'S331', rootCode: '331', fee: 276.3 },
  S332: { ...ADA_CODE_MAP['332'], code: 'S332', rootCode: '332', fee: 589.53 },
  S337: { ...ADA_CODE_MAP['337'], code: 'S337', rootCode: '337', fee: 316.94 },
  S338: { ...ADA_CODE_MAP['338'], code: 'S338', rootCode: '338', fee: 212.98 },
  S341: { ...ADA_CODE_MAP['341'], code: 'S341', rootCode: '341', fee: 432.75 },
  S343: { ...ADA_CODE_MAP['343'], code: 'S343', rootCode: '343', fee: 495.61 },
  S344: { ...ADA_CODE_MAP['344'], code: 'S344', rootCode: '344', fee: 1012.02 },
  S345: { ...ADA_CODE_MAP['345'], code: 'S345', rootCode: '345', fee: 1012.02 },
  S351: { ...ADA_CODE_MAP['351'], code: 'S351', rootCode: '351', fee: 278.02 },
  S352: { ...ADA_CODE_MAP['352'], code: 'S352', rootCode: '352', fee: 333.03 },
  S353: { ...ADA_CODE_MAP['353'], code: 'S353', rootCode: '353', fee: 725.27 },
  S354: { ...ADA_CODE_MAP['354'], code: 'S354', rootCode: '354', fee: 725.27 },
  S355: { ...ADA_CODE_MAP['355'], code: 'S355', rootCode: '355', fee: 942.87 },
  S359: { ...ADA_CODE_MAP['359'], code: 'S359', rootCode: '359', fee: 1479.58 },
  S361: { ...ADA_CODE_MAP['361'], code: 'S361', rootCode: '361', fee: 334.96 },
  S363: { ...ADA_CODE_MAP['363'], code: 'S363', rootCode: '363', fee: 1218.48 },
  S365: { ...ADA_CODE_MAP['365'], code: 'S365', rootCode: '365', fee: 1692.33 },
  S366: { ...ADA_CODE_MAP['366'], code: 'S366', rootCode: '366', fee: 1692.33 },
  S371: { ...ADA_CODE_MAP['371'], code: 'S371', rootCode: '371', fee: 262.2 },
  S373: { ...ADA_CODE_MAP['373'], code: 'S373', rootCode: '373', fee: 882.18 },
  S375: { ...ADA_CODE_MAP['375'], code: 'S375', rootCode: '375', fee: 787.9 },
  S376: { ...ADA_CODE_MAP['376'], code: 'S376', rootCode: '376', fee: 277.43 },
  S377: { ...ADA_CODE_MAP['377'], code: 'S377', rootCode: '377', fee: 327.76 },
  S378: { ...ADA_CODE_MAP['378'], code: 'S378', rootCode: '378', fee: 194.49 },
  S379: { ...ADA_CODE_MAP['379'], code: 'S379', rootCode: '379', fee: 471.43 },
  S381: { ...ADA_CODE_MAP['381'], code: 'S381', rootCode: '381', fee: 443.75 },
  S382: { ...ADA_CODE_MAP['382'], code: 'S382', rootCode: '382', fee: 503.23 },
  S384: { ...ADA_CODE_MAP['384'], code: 'S384', rootCode: '384', fee: 324.69 },
  S385: { ...ADA_CODE_MAP['385'], code: 'S385', rootCode: '385', fee: 503.23 },
  S386: { ...ADA_CODE_MAP['386'], code: 'S386', rootCode: '386', fee: 338.47 },
  S387: { ...ADA_CODE_MAP['387'], code: 'S387', rootCode: '387', fee: 648.53 },
  S388: { ...ADA_CODE_MAP['388'], code: 'S388', rootCode: '388', fee: 730.61 },
  S389: { ...ADA_CODE_MAP['389'], code: 'S389', rootCode: '389', fee: 240.07 },
  S391: { ...ADA_CODE_MAP['391'], code: 'S391', rootCode: '391', fee: 300.03 },
  S392: { ...ADA_CODE_MAP['392'], code: 'S392', rootCode: '392', fee: 157.51 },
  S393: { ...ADA_CODE_MAP['393'], code: 'S393', rootCode: '393', fee: 1011.3 },
  S394: { ...ADA_CODE_MAP['394'], code: 'S394', rootCode: '394', fee: 650.09 },
  S395: { ...ADA_CODE_MAP['395'], code: 'S395', rootCode: '395', fee: 1239.03 },
  S399: { ...ADA_CODE_MAP['399'], code: 'S399', rootCode: '399', fee: 76.88 },
  S411: { ...ADA_CODE_MAP['411'], code: 'S411', rootCode: '411', fee: 58.27 },
  S412: { ...ADA_CODE_MAP['412'], code: 'S412', rootCode: '412', fee: 240.69 },
  S414: { ...ADA_CODE_MAP['414'], code: 'S414', rootCode: '414', fee: 143.91 },
  S415: { ...ADA_CODE_MAP['415'], code: 'S415', rootCode: '415', fee: 499.6 },
  S416: { ...ADA_CODE_MAP['416'], code: 'S416', rootCode: '416', fee: 255.31 },
  S417: { ...ADA_CODE_MAP['417'], code: 'S417', rootCode: '417', fee: 499.6 },
  S418: { ...ADA_CODE_MAP['418'], code: 'S418', rootCode: '418', fee: 255.31 },
  S419: { ...ADA_CODE_MAP['419'], code: 'S419', rootCode: '419', fee: 267.08 },
  S421: { ...ADA_CODE_MAP['421'], code: 'S421', rootCode: '421', fee: 269.55 },
  S431: { ...ADA_CODE_MAP['431'], code: 'S431', rootCode: '431', fee: 495.61 },
  S432: { ...ADA_CODE_MAP['432'], code: 'S432', rootCode: '432', fee: 495.61 },
  S433: { ...ADA_CODE_MAP['433'], code: 'S433', rootCode: '433', fee: 200.54 },
  S434: { ...ADA_CODE_MAP['434'], code: 'S434', rootCode: '434', fee: 660.97 },
  S436: { ...ADA_CODE_MAP['436'], code: 'S436', rootCode: '436', fee: 459.35 },
  S437: { ...ADA_CODE_MAP['437'], code: 'S437', rootCode: '437', fee: 639.45 },
  S438: { ...ADA_CODE_MAP['438'], code: 'S438', rootCode: '438', fee: 472.16 },
  S445: { ...ADA_CODE_MAP['445'], code: 'S445', rootCode: '445', fee: 177.57 },
  S451: { ...ADA_CODE_MAP['451'], code: 'S451', rootCode: '451', fee: 177.57 },
  S452: { ...ADA_CODE_MAP['452'], code: 'S452', rootCode: '452', fee: 166.57 },
  S453: { ...ADA_CODE_MAP['453'], code: 'S453', rootCode: '453', fee: 155.58 },
  S455: { ...ADA_CODE_MAP['455'], code: 'S455', rootCode: '455', fee: 177.57 },
  S457: { ...ADA_CODE_MAP['457'], code: 'S457', rootCode: '457', fee: 177.57 },
  S458: { ...ADA_CODE_MAP['458'], code: 'S458', rootCode: '458', fee: 199.94 },
  S511: { ...ADA_CODE_MAP['511'], code: 'S511', rootCode: '511', fee: 167.3 },
  S512: { ...ADA_CODE_MAP['512'], code: 'S512', rootCode: '512', fee: 205.01 },
  S513: { ...ADA_CODE_MAP['513'], code: 'S513', rootCode: '513', fee: 244.41 },
  S514: { ...ADA_CODE_MAP['514'], code: 'S514', rootCode: '514', fee: 278.75 },
  S515: { ...ADA_CODE_MAP['515'], code: 'S515', rootCode: '515', fee: 318.29 },
  S521: { ...ADA_CODE_MAP['521'], code: 'S521', rootCode: '521', fee: 185.18 },
  S522: { ...ADA_CODE_MAP['522'], code: 'S522', rootCode: '522', fee: 224.73 },
  S523: { ...ADA_CODE_MAP['523'], code: 'S523', rootCode: '523', fee: 266.07 },
  S524: { ...ADA_CODE_MAP['524'], code: 'S524', rootCode: '524', fee: 307.4 },
  S525: { ...ADA_CODE_MAP['525'], code: 'S525', rootCode: '525', fee: 429.74 },
  S526: { ...ADA_CODE_MAP['526'], code: 'S526', rootCode: '526', fee: 529.09 },
  S531: { ...ADA_CODE_MAP['531'], code: 'S531', rootCode: '531', fee: 197.76 },
  S532: { ...ADA_CODE_MAP['532'], code: 'S532', rootCode: '532', fee: 248.18 },
  S533: { ...ADA_CODE_MAP['533'], code: 'S533', rootCode: '533', fee: 298.46 },
  S534: { ...ADA_CODE_MAP['534'], code: 'S534', rootCode: '534', fee: 336.28 },
  S535: { ...ADA_CODE_MAP['535'], code: 'S535', rootCode: '535', fee: 503.23 },
  S536: { ...ADA_CODE_MAP['536'], code: 'S536', rootCode: '536', fee: 529.09 },
  S541: { ...ADA_CODE_MAP['541'], code: 'S541', rootCode: '541', fee: 720.58 },
  S542: { ...ADA_CODE_MAP['542'], code: 'S542', rootCode: '542', fee: 906.96 },
  S543: { ...ADA_CODE_MAP['543'], code: 'S543', rootCode: '543', fee: 1244.47 },
  S544: { ...ADA_CODE_MAP['544'], code: 'S544', rootCode: '544', fee: 1454.09 },
  S545: { ...ADA_CODE_MAP['545'], code: 'S545', rootCode: '545', fee: 1800.14 },
  S551: { ...ADA_CODE_MAP['551'], code: 'S551', rootCode: '551', fee: 1136.76 },
  S552: { ...ADA_CODE_MAP['552'], code: 'S552', rootCode: '552', fee: 1272.86 },
  S553: { ...ADA_CODE_MAP['553'], code: 'S553', rootCode: '553', fee: 1579.06 },
  S554: { ...ADA_CODE_MAP['554'], code: 'S554', rootCode: '554', fee: 1698.13 },
  S555: { ...ADA_CODE_MAP['555'], code: 'S555', rootCode: '555', fee: 1800.14 },
  S556: { ...ADA_CODE_MAP['556'], code: 'S556', rootCode: '556', fee: 1963.95 },
  S571: { ...ADA_CODE_MAP['571'], code: 'S571', rootCode: '571', fee: 20.85 },
  S572: { ...ADA_CODE_MAP['572'], code: 'S572', rootCode: '572', fee: 135.84 },
  S574: { ...ADA_CODE_MAP['574'], code: 'S574', rootCode: '574', fee: 146.21 },
  S575: { ...ADA_CODE_MAP['575'], code: 'S575', rootCode: '575', fee: 44.97 },
  S577: { ...ADA_CODE_MAP['577'], code: 'S577', rootCode: '577', fee: 48.59 },
  S578: { ...ADA_CODE_MAP['578'], code: 'S578', rootCode: '578', fee: 48.59 },
  S579: { ...ADA_CODE_MAP['579'], code: 'S579', rootCode: '579', fee: 268.36 },
  S586: { ...ADA_CODE_MAP['586'], code: 'S586', rootCode: '586', fee: 224.16 },
  S587: { ...ADA_CODE_MAP['587'], code: 'S587', rootCode: '587', fee: 132.06 },
  S588: { ...ADA_CODE_MAP['588'], code: 'S588', rootCode: '588', fee: 173.76 },
  S595: { ...ADA_CODE_MAP['595'], code: 'S595', rootCode: '595', fee: 225.93 },
  S596: { ...ADA_CODE_MAP['596'], code: 'S596', rootCode: '596', fee: 126.92 },
  S597: { ...ADA_CODE_MAP['597'], code: 'S597', rootCode: '597', fee: 282.86 },
  S611: { ...ADA_CODE_MAP['611'], code: 'S611', rootCode: '611', fee: 1474.75 },
  S613: { ...ADA_CODE_MAP['613'], code: 'S613', rootCode: '613', fee: 2151.69 },
  S615: { ...ADA_CODE_MAP['615'], code: 'S615', rootCode: '615', fee: 2357.18 },
  S618: { ...ADA_CODE_MAP['618'], code: 'S618', rootCode: '618', fee: 1873.64 },
  S625: { ...ADA_CODE_MAP['625'], code: 'S625', rootCode: '625', fee: 510.25 },
  S627: { ...ADA_CODE_MAP['627'], code: 'S627', rootCode: '627', fee: 259.02 },
  S629: { ...ADA_CODE_MAP['629'], code: 'S629', rootCode: '629', fee: 518.21 },
  S631: { ...ADA_CODE_MAP['631'], code: 'S631', rootCode: '631', fee: 230.25 },
  S632: { ...ADA_CODE_MAP['632'], code: 'S632', rootCode: '632', fee: 448.99 },
  S633: { ...ADA_CODE_MAP['633'], code: 'S633', rootCode: '633', fee: 192.18 },
  S634: { ...ADA_CODE_MAP['634'], code: 'S634', rootCode: '634', fee: 349.8 },
  S642: { ...ADA_CODE_MAP['642'], code: 'S642', rootCode: '642', fee: 1547.27 },
  S643: { ...ADA_CODE_MAP['643'], code: 'S643', rootCode: '643', fee: 1423.61 },
  S644: { ...ADA_CODE_MAP['644'], code: 'S644', rootCode: '644', fee: 509.63 },
  S645: { ...ADA_CODE_MAP['645'], code: 'S645', rootCode: '645', fee: 502.75 },
  S649: { ...ADA_CODE_MAP['649'], code: 'S649', rootCode: '649', fee: 634.63 },
  S651: { ...ADA_CODE_MAP['651'], code: 'S651', rootCode: '651', fee: 161.17 },
  S652: { ...ADA_CODE_MAP['652'], code: 'S652', rootCode: '652', fee: 189.96 },
  S653: { ...ADA_CODE_MAP['653'], code: 'S653', rootCode: '653', fee: 222.2 },
  S655: { ...ADA_CODE_MAP['655'], code: 'S655', rootCode: '655', fee: 153.12 },
  S656: { ...ADA_CODE_MAP['656'], code: 'S656', rootCode: '656', fee: 222.06 },
  S658: { ...ADA_CODE_MAP['658'], code: 'S658', rootCode: '658', fee: 561.26 },
  S659: { ...ADA_CODE_MAP['659'], code: 'S659', rootCode: '659', fee: 255.65 },
  S661: { ...ADA_CODE_MAP['661'], code: 'S661', rootCode: '661', fee: 1151.24 },
  S663: { ...ADA_CODE_MAP['663'], code: 'S663', rootCode: '663', fee: 685.64 },
  S664: { ...ADA_CODE_MAP['664'], code: 'S664', rootCode: '664', fee: 1032.94 },
  S665: { ...ADA_CODE_MAP['665'], code: 'S665', rootCode: '665', fee: 1251.12 },
  S666: { ...ADA_CODE_MAP['666'], code: 'S666', rootCode: '666', fee: 1381.49 },
  S667: { ...ADA_CODE_MAP['667'], code: 'S667', rootCode: '667', fee: 1251.12 },
  S668: { ...ADA_CODE_MAP['668'], code: 'S668', rootCode: '668', fee: 511.3 },
  S669: { ...ADA_CODE_MAP['669'], code: 'S669', rootCode: '669', fee: 269.93 },
  S671: { ...ADA_CODE_MAP['671'], code: 'S671', rootCode: '671', fee: 2127.5 },
  S672: { ...ADA_CODE_MAP['672'], code: 'S672', rootCode: '672', fee: 2357.18 },
  S673: { ...ADA_CODE_MAP['673'], code: 'S673', rootCode: '673', fee: 1873.64 },
  S678: { ...ADA_CODE_MAP['678'], code: 'S678', rootCode: '678', fee: 536.15 },
  S679: { ...ADA_CODE_MAP['679'], code: 'S679', rootCode: '679', fee: 462.24 },
  S684: { ...ADA_CODE_MAP['684'], code: 'S684', rootCode: '684', fee: 2129.8 },
  S688: { ...ADA_CODE_MAP['688'], code: 'S688', rootCode: '688', fee: 2129.8 },
  S689: { ...ADA_CODE_MAP['689'], code: 'S689', rootCode: '689', fee: 908.43 },
  S690: { ...ADA_CODE_MAP['690'], code: 'S690', rootCode: '690', fee: 417.73 },
  S691: { ...ADA_CODE_MAP['691'], code: 'S691', rootCode: '691', fee: 666.18 },
  S711: { ...ADA_CODE_MAP['711'], code: 'S711', rootCode: '711', fee: 1496.62 },
  S712: { ...ADA_CODE_MAP['712'], code: 'S712', rootCode: '712', fee: 1496.62 },
  S713: { ...ADA_CODE_MAP['713'], code: 'S713', rootCode: '713', fee: 417.04 },
  S714: { ...ADA_CODE_MAP['714'], code: 'S714', rootCode: '714', fee: 417.04 },
  S715: { ...ADA_CODE_MAP['715'], code: 'S715', rootCode: '715', fee: 764.57 },
  S716: { ...ADA_CODE_MAP['716'], code: 'S716', rootCode: '716', fee: 456.82 },
  S719: { ...ADA_CODE_MAP['719'], code: 'S719', rootCode: '719', fee: 2993.23 },
  S721: { ...ADA_CODE_MAP['721'], code: 'S721', rootCode: '721', fee: 805.87 },
  S722: { ...ADA_CODE_MAP['722'], code: 'S722', rootCode: '722', fee: 805.87 },
  S723: { ...ADA_CODE_MAP['723'], code: 'S723', rootCode: '723', fee: 250.23 },
  S724: { ...ADA_CODE_MAP['724'], code: 'S724', rootCode: '724', fee: 250.23 },
  S727: { ...ADA_CODE_MAP['727'], code: 'S727', rootCode: '727', fee: 1835.2 },
  S728: { ...ADA_CODE_MAP['728'], code: 'S728', rootCode: '728', fee: 1835.2 },
  S731: { ...ADA_CODE_MAP['731'], code: 'S731', rootCode: '731', fee: 63.82 },
  S732: { ...ADA_CODE_MAP['732'], code: 'S732', rootCode: '732', fee: 51.82 },
  S733: { ...ADA_CODE_MAP['733'], code: 'S733', rootCode: '733', fee: 65.89 },
  S734: { ...ADA_CODE_MAP['734'], code: 'S734', rootCode: '734', fee: 109.88 },
  S735: { ...ADA_CODE_MAP['735'], code: 'S735', rootCode: '735', fee: 351.14 },
  S736: { ...ADA_CODE_MAP['736'], code: 'S736', rootCode: '736', fee: 54.12 },
  S737: { ...ADA_CODE_MAP['737'], code: 'S737', rootCode: '737', fee: 273.56 },
  S738: { ...ADA_CODE_MAP['738'], code: 'S738', rootCode: '738', fee: 254.94 },
  S739: { ...ADA_CODE_MAP['739'], code: 'S739', rootCode: '739', fee: 115.21 },
  S741: { ...ADA_CODE_MAP['741'], code: 'S741', rootCode: '741', fee: 75.56 },
  S743: { ...ADA_CODE_MAP['743'], code: 'S743', rootCode: '743', fee: 698.69 },
  S744: { ...ADA_CODE_MAP['744'], code: 'S744', rootCode: '744', fee: 543.37 },
  S745: { ...ADA_CODE_MAP['745'], code: 'S745', rootCode: '745', fee: 893.55 },
  S746: { ...ADA_CODE_MAP['746'], code: 'S746', rootCode: '746', fee: 733.88 },
  S751: { ...ADA_CODE_MAP['751'], code: 'S751', rootCode: '751', fee: 325.18 },
  S752: { ...ADA_CODE_MAP['752'], code: 'S752', rootCode: '752', fee: 254.7 },
  S753: { ...ADA_CODE_MAP['753'], code: 'S753', rootCode: '753', fee: 81.6 },
  S754: { ...ADA_CODE_MAP['754'], code: 'S754', rootCode: '754', fee: 212.4 },
  S761: { ...ADA_CODE_MAP['761'], code: 'S761', rootCode: '761', fee: 202.03 },
  S762: { ...ADA_CODE_MAP['762'], code: 'S762', rootCode: '762', fee: 217.95 },
  S763: { ...ADA_CODE_MAP['763'], code: 'S763', rootCode: '763', fee: 188.21 },
  S764: { ...ADA_CODE_MAP['764'], code: 'S764', rootCode: '764', fee: 208.53 },
  S765: { ...ADA_CODE_MAP['765'], code: 'S765', rootCode: '765', fee: 207.56 },
  S766: { ...ADA_CODE_MAP['766'], code: 'S766', rootCode: '766', fee: 127.21 },
  S768: { ...ADA_CODE_MAP['768'], code: 'S768', rootCode: '768', fee: 220.62 },
  S769: { ...ADA_CODE_MAP['769'], code: 'S769', rootCode: '769', fee: 263.89 },
  S771: { ...ADA_CODE_MAP['771'], code: 'S771', rootCode: '771', fee: 115.12 },
  S772: { ...ADA_CODE_MAP['772'], code: 'S772', rootCode: '772', fee: 541.91 },
  S773: { ...ADA_CODE_MAP['773'], code: 'S773', rootCode: '773', fee: 541.91 },
  S774: { ...ADA_CODE_MAP['774'], code: 'S774', rootCode: '774', fee: 1378.89 },
  S775: { ...ADA_CODE_MAP['775'], code: 'S775', rootCode: '775', fee: 309.21 },
  S776: { ...ADA_CODE_MAP['776'], code: 'S776', rootCode: '776', fee: 66.6 },
  S777: { ...ADA_CODE_MAP['777'], code: 'S777', rootCode: '777', fee: 53.31 },
  S778: { ...ADA_CODE_MAP['778'], code: 'S778', rootCode: '778', fee: 295.32 },
  S779: { ...ADA_CODE_MAP['779'], code: 'S779', rootCode: '779', fee: 531.77 },
  S811: { ...ADA_CODE_MAP['811'], code: 'S811', rootCode: '811', fee: 492.52 },
  S821: { ...ADA_CODE_MAP['821'], code: 'S821', rootCode: '821', fee: 1093.68 },
  S823: { ...ADA_CODE_MAP['823'], code: 'S823', rootCode: '823', fee: 1962.88 },
  S824: { ...ADA_CODE_MAP['824'], code: 'S824', rootCode: '824', fee: 460.49 },
  S825: { ...ADA_CODE_MAP['825'], code: 'S825', rootCode: '825', fee: 1618.59 },
  S829: { ...ADA_CODE_MAP['829'], code: 'S829', rootCode: '829', fee: 889.2 },
  S831: { ...ADA_CODE_MAP['831'], code: 'S831', rootCode: '831', fee: 2180 },
  S833: { ...ADA_CODE_MAP['833'], code: 'S833', rootCode: '833', fee: 225.2 },
  S841: { ...ADA_CODE_MAP['841'], code: 'S841', rootCode: '841', fee: 611.89 },
  S842: { ...ADA_CODE_MAP['842'], code: 'S842', rootCode: '842', fee: 557.01 },
  S843: { ...ADA_CODE_MAP['843'], code: 'S843', rootCode: '843', fee: 1338.52 },
  S845: { ...ADA_CODE_MAP['845'], code: 'S845', rootCode: '845', fee: 502.75 },
  S846: { ...ADA_CODE_MAP['846'], code: 'S846', rootCode: '846', fee: 588.57 },
  S851: { ...ADA_CODE_MAP['851'], code: 'S851', rootCode: '851', fee: 714.89 },
  S862: { ...ADA_CODE_MAP['862'], code: 'S862', rootCode: '862', fee: 192.07 },
  S871: { ...ADA_CODE_MAP['871'], code: 'S871', rootCode: '871', fee: 217.46 },
  S872: { ...ADA_CODE_MAP['872'], code: 'S872', rootCode: '872', fee: 137.62 },
  S873: { ...ADA_CODE_MAP['873'], code: 'S873', rootCode: '873', fee: 161.26 },
  S874: { ...ADA_CODE_MAP['874'], code: 'S874', rootCode: '874', fee: 150.14 },
  S875: { ...ADA_CODE_MAP['875'], code: 'S875', rootCode: '875', fee: 239.1 },
  S876: { ...ADA_CODE_MAP['876'], code: 'S876', rootCode: '876', fee: 186.65 },
  S877: { ...ADA_CODE_MAP['877'], code: 'S877', rootCode: '877', fee: 164.3 },
  S878: { ...ADA_CODE_MAP['878'], code: 'S878', rootCode: '878', fee: 254.82 },
  S881: { ...ADA_CODE_MAP['881'], code: 'S881', rootCode: '881', fee: 4398.26 },
  S911: { ...ADA_CODE_MAP['911'], code: 'S911', rootCode: '911', fee: 96.67 },
  S915: { ...ADA_CODE_MAP['915'], code: 'S915', rootCode: '915', fee: 130.95 },
  S916: { ...ADA_CODE_MAP['916'], code: 'S916', rootCode: '916', fee: 86.59 },
  S926: { ...ADA_CODE_MAP['926'], code: 'S926', rootCode: '926', fee: 193.4 },
  S927: { ...ADA_CODE_MAP['927'], code: 'S927', rootCode: '927', fee: 55.25 },
  S928: { ...ADA_CODE_MAP['928'], code: 'S928', rootCode: '928', fee: 133.62 },
  S941: { ...ADA_CODE_MAP['941'], code: 'S941', rootCode: '941', fee: 68.91 },
  S942: { ...ADA_CODE_MAP['942'], code: 'S942', rootCode: '942', fee: 121.35 },
  S943: { ...ADA_CODE_MAP['943'], code: 'S943', rootCode: '943', fee: 74.63 },
  S944: { ...ADA_CODE_MAP['944'], code: 'S944', rootCode: '944', fee: 229.2 },
  S945: { ...ADA_CODE_MAP['945'], code: 'S945', rootCode: '945', fee: 57.57 },
  S949: { ...ADA_CODE_MAP['949'], code: 'S949', rootCode: '949', fee: 154.2 },
  S961: { ...ADA_CODE_MAP['961'], code: 'S961', rootCode: '961', fee: 43.58 },
  S963: { ...ADA_CODE_MAP['963'], code: 'S963', rootCode: '963', fee: 105.06 },
  S964: { ...ADA_CODE_MAP['964'], code: 'S964', rootCode: '964', fee: 105.9 },
  S965: { ...ADA_CODE_MAP['965'], code: 'S965', rootCode: '965', fee: 760.26 },
  S966: { ...ADA_CODE_MAP['966'], code: 'S966', rootCode: '966', fee: 120.88 },
  S967: { ...ADA_CODE_MAP['967'], code: 'S967', rootCode: '967', fee: 200.44 },
  S968: { ...ADA_CODE_MAP['968'], code: 'S968', rootCode: '968', fee: 155.43 },
  S971: { ...ADA_CODE_MAP['971'], code: 'S971', rootCode: '971', fee: 51.82 },
  S972: { ...ADA_CODE_MAP['972'], code: 'S972', rootCode: '972', fee: 218.75 },
  S981: { ...ADA_CODE_MAP['981'], code: 'S981', rootCode: '981', fee: 122.48 },
  S982: { ...ADA_CODE_MAP['982'], code: 'S982', rootCode: '982', fee: 77.31 },
  S983: { ...ADA_CODE_MAP['983'], code: 'S983', rootCode: '983', fee: 1103.82 },
  S984: { ...ADA_CODE_MAP['984'], code: 'S984', rootCode: '984', fee: 1742.9 },
  S985: { ...ADA_CODE_MAP['985'], code: 'S985', rootCode: '985', fee: 132.4 },
  S986: { ...ADA_CODE_MAP['986'], code: 'S986', rootCode: '986', fee: 62.29 },
  S987: { ...ADA_CODE_MAP['987'], code: 'S987', rootCode: '987', fee: 74.84 },
  S990: { ...ADA_CODE_MAP['990'], code: 'S990', rootCode: '990', fee: 126.57 },
}).reduce(
  (codes, [key, code]) => ({
    ...codes,
    [key]: { ...(code as IServiceCode), type: ServiceCodeType.ADF },
  }),
  {} as ItemCodeAliases
);

export const ADF_CODE_MAP: ItemCodeAliases = {
  ...GENERAL_ADF_CODES,
  ...SPECIALIST_ADF_CODES,
};

export const ADF_SERVICE_CODES: IServiceCode[] = Object.values(ADF_CODE_MAP);

export const ADF_SERVICE: IServiceProvider = {
  label: 'ADF',
  description: 'ADF Health Services Schedule of Fees',
  type: ServiceCodeType.ADF,
  parentType: ServiceCodeType.ADA,
  items: ADF_CODE_MAP,
  region: Region.Australia,
};
